import React from 'react';
import {Field} from 'react-final-form';
import {FormFieldCheckbox} from '@yandex-data-ui/cloud-components';

import CalculatorFormLayout from 'components/calculator/CalculatorFormLayout/CalculatorFormLayout';
import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';

interface NetworkFieldProps extends WithTranslationProps {
    name: string;
}

const NetworkField: React.FC<NetworkFieldProps> = ({name, i18nK}) => (
    <CalculatorFormLayout.Row title={i18nK('field_network')} note={i18nK('context_network')}>
        <Field name={`${name}network`}>
            {(fieldProps) => <FormFieldCheckbox {...fieldProps} size="l" />}
        </Field>
    </CalculatorFormLayout.Row>
);

export default withTranslation('calculator')(NetworkField);
